import gql from 'graphql-tag';

export const GET_DEPARTMENTS_OPTIONS = gql`
  query GetDepartmentsOptions {
    bpf {
      result: departments {
        error
        success
        list {
          value: id
          label: name
        }
      }
    }
  }
`;
